class bundleProduct extends HTMLElement {

    constructor() {
      super();
      
      this.tabbing();
      this.addEvents();
      this.defineVariables();
      this.nextAndPreviousTabs();
      this.progressBarInit();
    }
  
    defineVariables() {
      this.variantArray = [];
      this.moneyFormat = this.querySelector("[bundle-section-main]").dataset.moneyFormat;
    }
  
    addEvents() {
      this.applyQuantityBtnEvents()
      this.applyAddToCartEvent()
      this.applybuyBundleEvent()
      this.applyreviewBundleEvent()    
    }
  
    hideUpcartCart(){
      if(upCart){
        upCart.classList.add("hide");
      }
    }
  
    applyreviewBundleEvent(){    
      document.querySelector("[review-bundle]").addEventListener("click", this.reviewBundle.bind(this, "review"));
      document.querySelector("[edit-remove-btn-wrapper] [edit-btn]").addEventListener("click", this.reviewBundle.bind(this, "edit"));
      document.querySelector("[edit-remove-btn-wrapper] [remove-btn]").addEventListener("click", this.reviewBundle.bind(this, "remove"));
      document.querySelector("[review-bundle-main] [create-new-bundle]").addEventListener("click", this.reviewBundle.bind(this, "remove"));
      document.querySelector("[review-bundle-main] [checkout-button]").addEventListener("click", this.clearCartAddProductsAndCheckout.bind(this));
    }
  
    reviewBundle(type, e) {
      e.preventDefault();
      switch (type) {
        case "review":
          document.querySelector("[review-bundle-main] .product-list").innerHTML = "";
          let subTotalPrice = 0;
          let discPercentage = 0.20;
          for (let varArr in this.variantArray) {
            subTotalPrice += parseInt(this.variantArray[varArr].variantPrice) * parseInt(this.variantArray[varArr].quantity);
            document.querySelector("[review-bundle-main] .product-list").innerHTML += `
              <li>${this.variantArray[varArr].quantity} x ${this.variantArray[varArr].variantTitle}</li>
            `;
          }
          subTotalPrice = (subTotalPrice / 100);
          let reviewBarDiscPercentage = typeof document.querySelectorAll('.progressbar-item.progress-threshold.completed')[document.querySelectorAll('.progressbar-item.progress-threshold.completed').length - 1] !== "undefined" ? parseFloat(document.querySelectorAll('.progressbar-item.progress-threshold.completed')[document.querySelectorAll('.progressbar-item.progress-threshold.completed').length - 1].dataset.discountPercentage) / 100 : 0;
          let reviewBarDiscountedPrice = 0;
          let reviewBarTotalBundleOriginalPrice = 0;
          
          for (let varArr in this.variantArray) {
            reviewBarTotalBundleOriginalPrice += parseInt(this.variantArray[varArr].variantPrice) * parseInt(this.variantArray[varArr].quantity);
          }
          
          reviewBarTotalBundleOriginalPrice = (reviewBarTotalBundleOriginalPrice / 100).toFixed(2);
          reviewBarDiscountedPrice = (reviewBarTotalBundleOriginalPrice * (1 - reviewBarDiscPercentage)).toFixed(2);
          document.querySelector("[review-bundle-main] .bc-price-info .bc-save-price").innerHTML = "Save " + (reviewBarTotalBundleOriginalPrice - reviewBarDiscountedPrice).toFixed(2);
          document.querySelector("[review-bundle-main] .bc-price-info .bc-total-price").innerHTML = this.moneyFormat.replace("{{amount}}", reviewBarDiscountedPrice);
          document.querySelector("[review-bundle-main] .bc-price-info .bc-original-price").innerHTML = this.moneyFormat.replace("{{amount}}", reviewBarTotalBundleOriginalPrice);
  
          document.querySelector("[review-bundle-main] [review-bundle-original] [review-bundle-original-span]").innerHTML = this.moneyFormat.replace("{{amount}}", reviewBarTotalBundleOriginalPrice);
          document.querySelector("[review-bundle-main] [review-bundle-discount] [review-bundle-discount-span]").innerHTML = this.moneyFormat.replace("{{amount}}", (reviewBarTotalBundleOriginalPrice - reviewBarDiscountedPrice).toFixed(2));
          document.querySelector("[review-bundle-main] [review-bundle-total-price] [review-bundle-total-price-span]").innerHTML = this.moneyFormat.replace("{{amount}}", (reviewBarTotalBundleOriginalPrice - ((reviewBarTotalBundleOriginalPrice - reviewBarDiscountedPrice).toFixed(2))).toFixed(2));
          
          document.querySelector("[review-bundle-main]").classList.remove("hidden");
          document.querySelector("[bundle-section-main]").classList.add("hidden");
          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          });
          
          break;
    
        case "edit":
          document.querySelector("[review-bundle-main]").classList.add("hidden");
          document.querySelector("[bundle-section-main]").classList.remove("hidden");
          break;
    
        case "remove":
          window.location.reload();
          break;
    
        default:
          // do nothing !!
          break;
      }
    }
  
    updateFooterBar() {
      let footerDiscPercentage = typeof document.querySelectorAll('.progressbar-item.progress-threshold.completed')[document.querySelectorAll('.progressbar-item.progress-threshold.completed').length - 1] !== "undefined" ? parseFloat(document.querySelectorAll('.progressbar-item.progress-threshold.completed')[document.querySelectorAll('.progressbar-item.progress-threshold.completed').length - 1].dataset.discountPercentage) / 100 : 0;
      let footerDiscountedPrice = 0;
      let footerTotalBundleOriginalPrice = 0;
      
      for (let varArr in this.variantArray) {
        footerTotalBundleOriginalPrice += parseInt(this.variantArray[varArr].variantPrice) * parseInt(this.variantArray[varArr].quantity);
      }
      
      // Convert the total price to a decimal to match the discount percentage format
      footerTotalBundleOriginalPrice = (footerTotalBundleOriginalPrice / 100).toFixed(2);
      
      // Calculate the discounted price
      footerDiscountedPrice = (footerTotalBundleOriginalPrice * (1 - footerDiscPercentage)).toFixed(2);
      
      // console.log(footerDiscPercentage, footerDiscountedPrice, footerTotalBundleOriginalPrice, this.moneyFormat);
  
      if((footerTotalBundleOriginalPrice - footerDiscountedPrice) > 0){
        document.querySelector("[bundle-footer] [bundle-footer-right] [bundle-price] [bundle-save-price]").classList.remove("hidden");
        document.querySelector("[bundle-footer] [bundle-footer-right] [bundle-price] [bundle-save-price]").innerHTML = "Save " + (footerTotalBundleOriginalPrice - footerDiscountedPrice).toFixed(2);
  
        document.querySelector("[bundle-footer] [bundle-footer-right] [bundle-price] [bundle-original-price]").classList.remove("hidden");
        document.querySelector("[bundle-footer] [bundle-footer-right] [bundle-price] [bundle-original-price] s[bundle-original-price-strike]").innerHTML = this.moneyFormat.replace("{{amount}}", footerTotalBundleOriginalPrice);
      }
      else{
        document.querySelector("[bundle-footer] [bundle-footer-right] [bundle-price] [bundle-save-price]").classList.add("hidden");
        document.querySelector("[bundle-footer] [bundle-footer-right] [bundle-price] [bundle-original-price]").classList.add("hidden");
      }
      document.querySelector("[bundle-footer] [bundle-footer-right] [bundle-price] [bundle-discopunted-price]").innerHTML =  this.moneyFormat.replace("{{amount}}", footerDiscountedPrice);
      
    }
  
    updateProgressBar(currentVal) {
      let prevThreshold = 0;
      let thresholdsLimitsArr = [];
  
      // Gather all threshold limits
      document.querySelectorAll(".progressbar-item.progress-threshold").forEach(el => {
        thresholdsLimitsArr.push(el.dataset.thresholdLimit);
        el.querySelector(".progressbar-line .progress-active").style.width = "0%";
      });
  
      // Iterate through each threshold element
      document.querySelectorAll(".progressbar-item.progress-threshold").forEach(el => {
          const thresholdLimit = parseInt(el.dataset.thresholdLimit);
  
        // console.log(thresholdLimit <= currentVal, thresholdLimit, currentVal);
          
          if (thresholdLimit <= currentVal) {
              prevThreshold = thresholdLimit;
              el.querySelector(".progressbar-line .progress-active").style.width = "100%";
              document.querySelectorAll(".progressbar-item.progress-threshold").forEach(ele => {
                  ele.classList.remove("active");
              });
              el.classList.add("active");
              // el.classList.add("completed");
          } else {
              if (thresholdLimit >= currentVal) {
                  const widthPercentage = ((currentVal - prevThreshold) / (thresholdLimit - prevThreshold)) * 100;
                  el.querySelector(".progressbar-line .progress-active").style.width = widthPercentage + "%";
                  prevThreshold = thresholdLimit;
                  return;
              }
          }
      });
  
      document.querySelectorAll(".progressbar-item.progress-threshold").forEach(el => {
        el.classList.remove("completed");
      })
      document.querySelectorAll(".progressbar-item.progress-threshold").forEach(el => {
        // console.log(el.dataset.thresholdLimit);
        console.log('==========XXXXXX============');
        console.log('currentVal', currentVal);
        console.log('el.dataset.thresholdLimit', el.dataset.thresholdLimit);
        console.log('==========ZZZZZZ===========');
        if(currentVal >= parseInt(el.dataset.thresholdLimit) ){
          el.classList.add("completed");
        }
      })
  
      // console.log(thresholdsLimitsArr);
  
      // Handle progress bar text update
      let completedElement = document.querySelectorAll('.progressbar-item.progress-threshold')[0];
      let nextElement = completedElement;
  
      if(typeof document.querySelectorAll('.progressbar-item.progress-threshold.completed')[document.querySelectorAll('.progressbar-item.progress-threshold.completed').length - 1] !== "undefined"){
        completedElement = document.querySelectorAll('.progressbar-item.progress-threshold.completed')[document.querySelectorAll('.progressbar-item.progress-threshold.completed').length - 1];
        nextElement = completedElement?.nextElementSibling;
      }
  
      let nextPercentage = nextElement ? nextElement.dataset.discountPercentage : null;
      let currentPercentage = completedElement ? completedElement.dataset.discountPercentage : null;
  
      if (currentVal < parseInt(thresholdsLimitsArr[0])) {
          // console.log('add 1 more to get 10% off');
          let remainingProd = parseInt(thresholdsLimitsArr[0]) - currentVal;
          document.querySelector("[bundle-section-main] .bundle-progressbar .progressbar-text span").innerHTML = document.querySelector(".bundle-header-progressbar .progressbar-text").dataset.textTemplateZeroThreshold.replace("##remainingproduct##", remainingProd).replace("##remainingpercentageoff##", Math.round(nextPercentage));
      } else {
          for (let i = 0; i < thresholdsLimitsArr.length - 1; i++) {
              let prevVal = parseInt(thresholdsLimitsArr[i]);
              let nextVal = parseInt(thresholdsLimitsArr[i + 1]);
  
              if (currentVal >= prevVal && currentVal < nextVal) {
                  // console.log(`add ${nextVal - currentVal} more`);
                  let remainingProd = nextVal - currentVal;
                  document.querySelector("[bundle-section-main] .bundle-progressbar .progressbar-text span").innerHTML = document.querySelector(".bundle-header-progressbar .progressbar-text").dataset.textTemplateBetweenThreshold.replace("##percentageoff##", Math.round(currentPercentage)).replace("##remainingproduct##", remainingProd).replace("##remainingpercentageoff##", Math.round(nextPercentage));
                  break;
              }
          }
  
          if (currentVal >= parseInt(thresholdsLimitsArr[thresholdsLimitsArr.length - 1])) {
              // console.log('woo hooo 30% off');
              document.querySelector("[bundle-section-main] .bundle-progressbar .progressbar-text span").innerHTML = document.querySelector(".bundle-header-progressbar .progressbar-text").dataset.textTemplateEndThreshold.replace("##percentageoff##", Math.round(currentPercentage));
          }
      }
      this.updateFooterBar()
  }
  
    progressBarInit() {
      var bar = document.querySelector('.progressbar-bar');
      var thresholds = document.querySelectorAll('.progressbar-threshold');
      
      thresholds.forEach(function(threshold) {
        threshold.addEventListener('click', function() {
          var left = threshold.style.left;
          var width = parseInt(left.substring(0, left.length-1));
      
          bar.style.width = width + '%';
      
          thresholds.forEach(function(t) {
            t.classList.remove('active');
          });
      
          threshold.classList.add('active');
        });
      });
    }
  
    applybuyBundleEvent(){
      this.querySelector(".buy-bundle-btn .buy-bundle").addEventListener("click", this.addBundleProducts.bind(this));
    }
  
    addBundleProducts(e){
      this.addProductJS();
    }
  
    clearCartAddProductsAndCheckout(e){
  
      this.hideUpcartCart();
  
      fetch('/cart/clear.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then(response => {
        if (response.ok) {
          return response.json();
        }
        throw new Error('Network response was not ok.');
      })
      .then(data => {
        // console.log("cart cleared");
        this.addProductJS('checkout');
      })
      .catch(error => {
        console.error('There was a problem with the fetch operation:', error);
      });
      
    }
  
    generateUniqueId() {
      const timestamp = Date.now();
      const randomNum = Math.floor(Math.random() * 1000000);
      return `${timestamp}-${randomNum}`;
    }
  
    addProductJS(redirect = null){
      let _this1 = this;
      let variantsArray = this.variantArray;
      let finalVariantsJson = [];
      let uniqueId = this.generateUniqueId();
      for (let pvar in variantsArray) {
        let variantsJson = {};
        variantsJson["id"] = pvar;
        variantsJson["quantity"] = variantsArray[pvar]['quantity'];
        if(typeof document.querySelectorAll('.progressbar-item.progress-threshold.completed')[document.querySelectorAll('.progressbar-item.progress-threshold.completed').length - 1] !== "undefined"){
          variantsJson["properties"] = {
            "_bundle_discount" : document.querySelectorAll('.progressbar-item.progress-threshold.completed')[document.querySelectorAll('.progressbar-item.progress-threshold.completed').length - 1].dataset.discountPercentage,
            "_bundle_handle": location.href.split("?")[0].split("/")[location.href.split("?")[0].split("/").length - 1],
            "_bundle_id": uniqueId,
            "_bundle_thresholds": _this1.dataset.bundleThresholds
          }
        }
        finalVariantsJson.push(variantsJson);
      }
      let formData = {
       'items': finalVariantsJson
      };
      // console.log(JSON.stringify(formData));
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => {
        return response.json();
      })
      .then(response => {
        // window.upcartRefreshCart();
        // window.upcartOpenCart();
        if(redirect){
          location.href="/" + redirect;
        }
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    }
  
    applyAddToCartEvent() {
      document.querySelectorAll(".variant-atc-btn").forEach(el => {
        el.addEventListener("click", (e) => {
          const variantWrapper = e.currentTarget.closest(".variant-wrapper.variant-data");
          const variantId = parseInt(variantWrapper.dataset.variant_id);
          const variantSrc = variantWrapper.dataset.variant_src;
          const variantTitle = variantWrapper.dataset.variant_title;
          const variantPrice = variantWrapper.dataset.variant_price;
          const quantity = variantWrapper.querySelector(".quantity-btns .quantity").value;
      
          e.currentTarget.closest(".variant-details").querySelector(".js-atc-btn").classList.add("show")
          e.currentTarget.closest(".variant-details").querySelector(".quantity-btns").classList.remove("show")
      
          if (!this.variantArray) {
            this.variantArray = [];
          }
      
          let groupDiscount = e.currentTarget.closest(".tab-content").dataset.tab_discount;
      
          if (quantity > 0) {
            this.variantArray[variantId] = {
              quantity: quantity,
              groupDiscount: groupDiscount,
              variantSrc: variantSrc,
              variantTitle: variantTitle,
              variantPrice: variantPrice
            };
            e.currentTarget.closest(".variant-details").querySelector(".js-atc-btn").classList.remove("show")
            e.currentTarget.closest(".variant-details").querySelector(".quantity-btns").classList.add("show")
          } else {
            variantWrapper.querySelector(".quantity-btns .quantity").value = 1;
            delete this.variantArray[variantId];
          }
  
  
          document.querySelectorAll('bundle-product .added-products').forEach(el => {
            el.innerHTML = "";
            let counter = 0;
            for (let varArr in this.variantArray) {
              counter = counter + 1;
              el.innerHTML += `
                <div class="added-product-item">
                  <div class="added-product-box">
                    <span class="remove-product" data-variant_id="${varArr}">X</span>
                    <div class="added-product-img">
                      <img src="${this.variantArray[varArr].variantSrc}" alt="Product Image">
                    </div>
                  </div>
                </div>
              `;
            }
            
            // console.log("this.variantArray.length", this.variantArray.length, this.variantArray.length < 1);
            document.querySelector("[bundle-header-progressbar] [bundle-footer]").classList.remove("hide");
            if(counter < 1){
              document.querySelector("[bundle-header-progressbar] [bundle-footer]").classList.add("hide");
              el.innerHTML += `
                <div class="added-product-item">
                </div>
              `;
            }
          })
          
          let totalQuantity = 0;
          for (let variantId in this.variantArray) {
            totalQuantity += parseInt(this.variantArray[variantId].quantity);
          }
          this.updateProgressBar(totalQuantity)
          this.applyRemoveProductEvent();
  
          
      
          // console.log("this.variantArray", this.variantArray);
        });
      });
    }
  
    applyRemoveProductEvent(){
      document.querySelectorAll(".remove-product").forEach(el => {
        el.addEventListener("click", function(e){
          document.querySelector(`[data-variant_id='${e.currentTarget.dataset.variant_id}'] .quantity-btns input.quantity`).value = 1;
          document.querySelector(`[data-variant_id='${e.currentTarget.dataset.variant_id}'] .quantity-btns .variant-atc-btn`).dispatchEvent(new Event('click', { bubbles: true }));
        })
      })
    }
  
    applyQuantityBtnEvents(){
      this.querySelectorAll(".incdec-btn").forEach(el => {
        el.addEventListener("click", function(e){
          let quantityInput = e.currentTarget.closest(".quantity-btns").querySelector("input.quantity");
          if(e.currentTarget.classList.contains("plus")){
            quantityInput.value = parseInt(quantityInput.value) + 1;
          }
          else if(e.currentTarget.classList.contains("minus") && parseInt(quantityInput.value) > 0 ){
            quantityInput.value = parseInt(quantityInput.value) - 1;
          }
        })
      })
    }
  
    tabbing() {
  
      this.querySelector(".bundle-content .bundle-content-heading h2").innerHTML = this.querySelector(".bundle-container .bundle-navigation .bundle-tab.active").dataset.tabTitle;
      
      const tabs = document.querySelectorAll('bundle-product .tab');
      const tabContents = document.querySelectorAll('bundle-product .tab-content');
      let _this2 = this;
    
      tabs.forEach(tab => {
        tab.addEventListener('click', function() {
          const target = this.getAttribute('data-tab');
          const targetTitle = this.getAttribute('data-tab-title');
    
          tabs.forEach(t => t.classList.remove('active'));
          tabContents.forEach(tc => tc.classList.remove('active'));
          _this2.querySelector(".bundle-content .bundle-content-heading h2").innerHTML = targetTitle;
    
          this.classList.add('active');
          document.querySelector(`.${target}`).classList.add('active');
        });
      });
    }
  
    nextAndPreviousTabs(){
      const tabs = document.querySelectorAll(".tabbing .tab");
      const tabContents = document.querySelectorAll(".tabbing-products .tab-content");
      let currentTabIndex = 0;
    
      function showTab(index) {
        tabs.forEach((tab, i) => {
          tab.classList.toggle("active", i === index);
          tabContents[i].classList.toggle("active", i === index);
        });
        currentTabIndex = index;
        const isMobile = window.innerWidth < 768;
        const offsetTop = document.querySelector(".bundle-content").offsetTop;
        const scrollTop = isMobile?offsetTop-20:offsetTop;
        window.scrollTo({
          top: scrollTop - 130,
          behavior: 'smooth'
        });
      }
    
      tabs.forEach((tab, index) => {
        tab.addEventListener("click", () => {
          showTab(index);
        });
      });
    }
    
    connectedCallback() {
      // console.log("Custom element added to page.");
    }
  
    disconnectedCallback() {
      // console.log("Custom element removed from page.");
    }
  
    adoptedCallback() {
      // console.log("Custom element moved to new page.");
    }
  
    attributeChangedCallback(name, oldValue, newValue) {
      // console.log(`Attribute ${name} has changed.`);
    }
  }
  
  customElements.define("bundle-product", bundleProduct);